'use es6';

import RecordPropType from 'conversations-prop-types/prop-types/RecordPropType';
import { getSource, getSourceId, getTimestamp, getUpdate } from 'conversations-message-history/crm-object-lifecycle-update/operators/crmObjectLifecycleUpdateGetters';
import { isSystemUpdate } from 'conversations-message-history/crm-object-lifecycle-update/operators/isSystemUpdate';
import { getPipelineStage } from 'conversations-message-history/crm-object-lifecycle-update/operators/ticketUpdateMetadataGetters';
import SkeletonText from 'conversations-skeleton-state/components/SkeletonText';
import I18n from 'I18n';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import PropTypes from 'prop-types';
import SenderMap from 'conversations-message-history/proptypes/SenderMap';
import FullSenderName from '../senders/components/FullSenderName';
import { findSender } from 'conversations-message-history/senders/operators/findSender';
import { getData } from 'conversations-message-history/senders/operators/getters';
import { isSenderLoading } from 'conversations-message-history/senders/operators/isSenderLoading';
import { getDateString } from 'conversations-message-history/util/labelDateUtils';
import { jsx as _jsx } from "react/jsx-runtime";
const CrmTicketUpdatedMessage = ({
  message,
  senders,
  userId
}) => {
  const senderId = getSourceId(message);
  const senderType = getSource(message);
  const timestamp = getTimestamp(message);
  const momentTimestamp = I18n.moment(timestamp);
  const messageOptions = {
    dateString: getDateString(momentTimestamp),
    pipelineStage: /*#__PURE__*/_jsx("b", {
      children: getPipelineStage(getUpdate(message))
    })
  };
  if (senderId === userId) {
    return /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "conversations-inbox-message-history.crm-ticket-lifecycle-update.update.currentAgent",
      options: messageOptions
    });
  }
  if (isSystemUpdate(message)) {
    return /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "conversations-inbox-message-history.crm-ticket-lifecycle-update.update.system",
      options: messageOptions
    });
  }
  const asyncSender = findSender(senderId, senderType, senders);
  const isLoading = isSenderLoading(asyncSender);
  if (isLoading) {
    return /*#__PURE__*/_jsx(SkeletonText, {
      width: 200
    });
  }
  return /*#__PURE__*/_jsx(FormattedReactMessage, {
    message: "conversations-inbox-message-history.crm-ticket-lifecycle-update.update.agent",
    options: Object.assign({
      agent: /*#__PURE__*/_jsx("b", {
        children: /*#__PURE__*/_jsx(FullSenderName, {
          sender: getData(asyncSender)
        })
      })
    }, messageOptions)
  });
};
CrmTicketUpdatedMessage.displayName = 'CrmTicketUpdatedMessage';
CrmTicketUpdatedMessage.propTypes = {
  message: RecordPropType('CrmObjectLifecycleUpdate').isRequired,
  senders: SenderMap.isRequired,
  userId: PropTypes.number.isRequired
};
export default CrmTicketUpdatedMessage;